import {del, get, patch, post, put} from './axios2'
import _ from 'lodash'
import {OK} from 'http-status-codes'
import {addHeaders} from './authHeader'
import {camelize} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'

const { VUE_APP_OIDC_CLIENT_ID, VUE_APP_OIDC_ISSUER } = process.env
const ptracApiUri = process.env.VUE_APP_PTRAC_API_URI + '/'

// use ptracGet for boolean queries or custom endpoints (things in controller package java)
export async function ptracGet(url) {
  return await request(url, null, 'get')
}

export async function ptracPut(url, data) {
  return await request(url, data, 'put')
}

export async function ptracPost(url, data) {
  return await request(url, data, 'post')
}

export async function ptracPatch(url, data) {
  return await request(url, data, 'patch')
}

// use ptracGetEntity for single item returns (ie fetchOne)
export async function ptracGetEntity(url) {
  const response = await request(url, null, 'get')

  if (OK === response.status) {
    // remove props that aren't used in PTRAC Admin
    const entity = response.data
    delete entity._links
    delete entity.dateCreated
    delete entity.dateUpdated
  }

  return response
}

// use ptracPostEntities for lists - usually for read queries that are too complex or large or a URL
export async function ptracPostEntities(url, whichEntity = null, data) {
  const response = await request(url, data, 'post')
  return extractResponse(url, whichEntity, response)
}

// use ptracGetEntities for lists
export async function ptracGetEntities(url, whichEntity = null) {
  const response = await request(url, null, 'get')
  return extractResponse(url, whichEntity, response)
}

function extractResponse(url, whichEntity, response) {
  if (OK === response.status) {
    if (!whichEntity) {
      let end = url.length
      if (url.indexOf('/') > 0) {
        end = url.indexOf('/')
      } else if (url.indexOf('?')) {
        end = url.indexOf('?')
      }
      whichEntity = url.substring(0, end)

      //for multi-word entities. EX 'task-names' -> 'taskNames'
      if (whichEntity.indexOf('-') > 0) {
        whichEntity = camelize(whichEntity)
      }
    }

    if (_.get(response, 'data._embedded.' + whichEntity)) {
      const entities = _.pick(response.data._embedded, whichEntity)[whichEntity]
      entities.forEach(entity => { delete entity._links})
      response.data = entities
      return response
    }
  }

  return response
}

export async function ptracPatchEntity(url, data) {
  return await request(url, data, 'patch')
}

export async function ptracPostEntity(url, data) {
  return await request(url, data, 'post')
}

export async function ptracPutEntity(url, data) {
  return await request(url, data, 'put')
}

export async function ptracDeleteEntity(url) {
  return await request(url, null, 'delete')
}

export async function ptracAutocomplete(url) {
  return await request(url, null, 'get')
}

export async function ptracApiUp() {
  return await request('actuator/health', null, 'get')
}

async function request(url, data, method) {
  switch (method) {
    case 'get':
      return await get(ptracApiUri + url, await addHeaders())
    case 'put':
      return await put(ptracApiUri + url, await addHeaders(), data)
    case 'post':
      return await post(ptracApiUri + url, await addHeaders(), data)
    case 'patch':
      return await patch(ptracApiUri + url, await addHeaders(Constants.HEADERS.MERGE_PATCH.headers), data)
    case 'delete':
      return await del(ptracApiUri + url, await addHeaders())
  }
}

// function isTokenExpired(accessToken) {
//   return accessToken.expiresAt < Math.round(new Date().getTime() / 1000)
// }

// const refreshAuthToken = async (refreshToken) => {
//   try {
//     const response = await fetch(`${VUE_APP_OIDC_ISSUER}/v1/token`, {
//       method: 'POST',
//       headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/x-www-form-urlencoded'
//       },
//       body: new URLSearchParams({
//         grant_type: 'refresh_token',
//         refresh_token: refreshToken,
//         client_id: VUE_APP_OIDC_CLIENT_ID,
//         scope: 'openid profile email offline_access'
//       })
//     })
//
//     if (!response.ok) {
//       console.error(await response.json())
//       return response;
//     }
//
//     const tokens = await response.json()
//
//     const newIdToken = tokens['id_token']
//     const newAccessToken = tokens['access_token']
//     const newRefreshToken = tokens['refresh_token']
//
//     const oktaTokenStorage = JSON.parse(localStorage.getItem('okta-token-storage'))
//
//     oktaTokenStorage.idToken.value = newIdToken
//     oktaTokenStorage.idToken.idToken = newIdToken
//     oktaTokenStorage.idToken.expiresAt = oktaTokenStorage.idToken.expiresAt + tokens['expires_in']
//     oktaTokenStorage.accessToken.value = newAccessToken
//     oktaTokenStorage.accessToken.accessToken = newAccessToken
//     oktaTokenStorage.accessToken.expiresAt = oktaTokenStorage.accessToken.expiresAt + tokens['expires_in']
//     oktaTokenStorage.refreshToken.value = newRefreshToken
//     oktaTokenStorage.refreshToken.refreshToken = newRefreshToken
//     oktaTokenStorage.refreshToken.expiresAt = oktaTokenStorage.refreshToken.expiresAt + tokens['expires_in']
//
//     localStorage.setItem('okta-token-storage', JSON.stringify(oktaTokenStorage))
//
//     return response
//   } catch (error) {
//     console.error('Okta token refresh failed. Clearing okta-token-storage from localStorage', error);
//     localStorage.removeItem('okta-token-storage')
//   }
// }
